module.exports = __webpack_public_path__ + "img/Tristan da Cunha.220c3569.svg";